import type { OrgArtifactViewDefinitionLike } from '../models/orgArtifactKind';

export type AtlasProjectionMode = 'live' | 'scenario';

export function isAtlasPositionProjection(view: OrgArtifactViewDefinitionLike | null | undefined): boolean {
  return view?.type === 'position-chart' || view?.projection === 'position_chart'
    || (view?.projection === 'planning_chart'
      && view.filters?.presentationOnly === true
      && view.filters.planningProjection === 'position');
}

export function isStaleOrgScenario(error: unknown): boolean {
  return (error as { status?: number } | null)?.status === 409;
}

export function isAtlasFolderProjection(view: OrgArtifactViewDefinitionLike | null | undefined): boolean {
  return view?.projection === 'people_chart' || view?.projection === 'position_chart'
    || view?.projection === 'planning_chart' || view?.type === 'position-chart'
    || view?.type === 'planning-chart';
}

/** View kind and revision selection are shared context, never pane-local truth. */
export function atlasProjectionMode(
  view: OrgArtifactViewDefinitionLike | null | undefined,
  hasSelectedScenario: boolean,
  requested?: AtlasProjectionMode,
): AtlasProjectionMode {
  if (view?.projection === 'planning_chart') return 'scenario';
  return requested ?? (hasSelectedScenario ? 'scenario' : 'live');
}

export class AtlasProjectionContextError extends Error {
  readonly code = 'planning_requires_scenario';
  constructor() { super('Planning artifacts accept scenario mutations only.'); }
}

/** Defense in depth: a stale client must not choose a live destination for a draft. */
export function assertAtlasMutationContext(
  view: OrgArtifactViewDefinitionLike | null | undefined,
  mode: AtlasProjectionMode,
): void {
  if (view?.projection === 'planning_chart' && mode !== 'scenario') {
    throw new AtlasProjectionContextError();
  }
}
